import { render } from "./EventReport.vue?vue&type=template&id=0524b48a&scoped=true"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"

import "./EventReport.vue?vue&type=style&index=0&id=0524b48a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0524b48a"]])

export default __exports__